function timerVirtual(user,name,stats){
    this.user=copyObj(user);
    this.name=name;
    this.stats=copyObj(stats);
    if(this.user.time_start && typeof stats!="undefined"){
        this.onStart();
    }
};
timerVirtual.prototype={
    updateUser:function(user){
        var user_old=copyObj(this.user);
        this.user=copyObj(user);
        if(user_old.time_start==0 && this.user.time_start>0){
           this.onStart(); 
        }
        
    },
    takeTimeBonus:function(){
        var bonus=_userArr['speed_bonus_global'];
        return bonus;
    },
    makeStatus:function(){
        
        if(this.user['time_start']==0){
            return false;
        }
        if(typeof this.user["is_blocked"]!="undefined" && this.user["is_blocked"]){
            return false;
        }
        if(this.user['level']>=this.user['level_max']){
            this.user['howlong_have']=this.user["howlong_end"];
            return false;
        }
        var howlong=this.takeHowlongAdd(this.user['time_start']);
        if(howlong<1){
            return false;
        }
        
        var level=this.user['level'];
       
        howlong+=this.user['howlong_have'];
        var stat=this.user['howlong_end'];
        while (howlong>=stat && typeof(this.stats[level+1])!="undefined"){
            level++;
            howlong-=stat;
            if(typeof(this.stats[level+1])!="undefined"){
                stat=this.stats[level+1];
            }
            else{
                break;
            }
        }
        this.user['howlong_have']=howlong;
        this.user['time_start']=getCurrentTime();
        
        if(level>this.user.level){
            this.user.howlong_end=stat;
            this.user['level']=level;
            _eventHandler.trigger(this.name+"NewLevel",{id:this.user.id,level:level});
            this.onStart();
        }
    },
    getLevel:function(){
        this.makeStatus();
        return this.user.level;
    },
    getLevelMax:function(){
        return this.user.level_max;  
    },
    onStart:function(){
        var this_tmp=this;
        _timerManager.addFunctionOnTime(function(){
            this_tmp.makeStatus();
        },this.takeNewLevelTime());
    },
    takeHowlongAdd:function(time_start,time_end){
        if(typeof time_end=="undefined" || time_end==0){
            time_end=getCurrentTime();
        }
        var bonus_percent=this.takeTimeBonus();
        var howlong=time_end-time_start;
        howlong=Math.floor(bonus_percent*howlong);
        
        
        if(howlong<0){
            return 0;
        }
        return howlong;
    },
    takeNewLevelTime:function(){
        this.makeStatus();
        var howlong_need=this.user['howlong_end']-this.user['howlong_have'];
        var bonus=this.takeTimeBonus();
        var howlong_real=Math.ceil(howlong_need/bonus);
        return (getCurrentTime()+howlong_real);
    },
    takeTimeToLevel:function(level){
        var cur_level=this.getLevel();
        if(cur_level<level){
            var time_end=this.takeNewLevelTime(),time_add=0,i;
            for(i=cur_level+1;i<level;i++){
                if(typeof this.stats[i+1]!="undefined"){
                    time_add+=intval(this.stats[i+1]);
                }
            }
            time_add=Math.ceil(time_add/this.takeTimeBonus());
            return (time_end+time_add);
        }
        else{
            return 0;
        }
    },
    isWorking:function(){
        if(this.user.time_start==0){
            return 0;
        }
        return 1;
    },
    takeTimerObj:function(){
        var obj={active:1};
        if(this.user["time_start"]==0){
            obj.active=0;
        }
        obj.time_end=this.takeNewLevelTime();
        obj.howlong_end=this.user["howlong_end"];
        obj.howlong_have=this.user["howlong_have"];
        
        return obj;
    }
};


function timerVirtualSet(name){
    this.name=name;
    this.stats={};
    this.objSet={};
};
timerVirtualSet.prototype={
    init:function(stats,user_arr){
        this.stats=copyObj(stats);
        var id;
        for(id in this.stats){
            this.objSet[id]=new timerVirtual(user_arr[id],this.name,this.stats[id]);
        }
    },
    updateSet:function(user_arr){
        var id;
        for(id in user_arr){
            this.objSet[id].updateUser(user_arr[id]);
        }
    }
    
};

var _SkillSet=new timerVirtualSet("skill");